"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.EJSONCache = void 0;
var ejson_1 = __importDefault(require("ejson"));
var object_sizeof_1 = __importDefault(require("object-sizeof"));
var EJSONCache = /** @class */ (function () {
    function EJSONCache(adapter, storageKeyPrefix) {
        var _this = this;
        this._memoryCache = {};
        this._preloadedPromises = {};
        this.getPreloaded = function (key) {
            var _a;
            if (_this._memCacheMeta[key] != null) {
                _this._memCacheMeta[key].l = Math.floor(Date.now() / 1000);
            }
            return (_a = _this._memoryCache[key]) !== null && _a !== void 0 ? _a : null;
        };
        this._memCacheCurrent = { bytes: 0 };
        /**
         * For efficiency
         * b = bytes
         * l = last used in seconds
         */
        this._memCacheMeta = {};
        this._storeDataToMemory = function (key, value) {
            var _a, _b, _c;
            var size = (0, object_sizeof_1["default"])(value);
            var prevSize = ((_c = (_b = (_a = _this._memCacheMeta) === null || _a === void 0 ? void 0 : _a[key]) === null || _b === void 0 ? void 0 : _b.b) !== null && _c !== void 0 ? _c : 0);
            var diff = size - prevSize;
            _this._memCacheMeta[key] = { b: size, l: Math.floor(Date.now() / 1000) };
            _this._memCacheCurrent.bytes += diff;
            _this._memoryCache[key] = value;
            if (_this._memCacheCurrent.bytes >= 1000 * 1000 * 500) {
                // @ts-expect-error console is universal
                console.error('!!! ERROR WARNING ERROR WARNING !!! [EJSONCache] MemCache exceeding 500 mb. DUMPING MEMORY CACHE !!!');
                // Safety Measure during initial testing
                _this._memCacheCurrent = { bytes: 0 };
                _this._memCacheMeta = {};
                _this._memoryCache = {};
            }
        };
        this.preload = function (key) {
            if (key in _this._memoryCache) {
                return;
            }
            var promise = _this.adapter.getItem(_this.storageKeyPrefix + key);
            _this._preloadedPromises[key] = promise;
            promise
                .then(function (res) {
                if (_this._preloadedPromises[key] === promise) {
                    delete _this._preloadedPromises[key];
                    if (res !== null) {
                        _this._storeDataToMemory(key, ejson_1["default"].parse(res));
                    }
                }
            })["catch"](function () {
                if (_this._preloadedPromises[key] === promise) {
                    delete _this._preloadedPromises[key];
                }
            });
        };
        this.get = function (key) { return __awaiter(_this, void 0, void 0, function () {
            var preloaded, value, _a, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        preloaded = this.getPreloaded(key);
                        if (preloaded !== null) {
                            return [2 /*return*/, preloaded];
                        }
                        if (!(key in this._preloadedPromises)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._preloadedPromises[key]];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.adapter.getItem(this.storageKeyPrefix + key)];
                    case 3:
                        _a = _b.sent();
                        _b.label = 4;
                    case 4:
                        value = _a;
                        if (value === null) {
                            return [2 /*return*/, null];
                        }
                        data = ejson_1["default"].parse(value);
                        this._storeDataToMemory(key, data);
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.set = function (key, value) { return __awaiter(_this, void 0, void 0, function () {
            var serializedValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serializedValue = ejson_1["default"].stringify(value);
                        this._storeDataToMemory(key, value);
                        return [4 /*yield*/, this.adapter.setItem(this.storageKeyPrefix + key, serializedValue)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.mutate = function (key, mutator, defaultValue) { return __awaiter(_this, void 0, void 0, function () {
            var value, mutatedValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(key)];
                    case 1:
                        value = _a.sent();
                        mutatedValue = mutator(value !== null && value !== void 0 ? value : defaultValue);
                        return [4 /*yield*/, this.set(key, mutatedValue)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, mutatedValue];
                }
            });
        }); };
        this.adapter = adapter;
        this.storageKeyPrefix = storageKeyPrefix !== null && storageKeyPrefix !== void 0 ? storageKeyPrefix : '';
    }
    return EJSONCache;
}());
exports.EJSONCache = EJSONCache;
